import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, timeout: 20000 });

export async function submitLead(payload) {
    const { data } = await api.post("/leads", { ...payload, website: "" });
    return data;
}

export async function fetchAppSettings() {
    const { data } = await api.get("/app-settings");
    return data;
}
